// React binding over the offline mutation queue.
import { useEffect, useState } from 'react';
import { onQueueChange, queueStatus, type QueueStatus } from './offlineQueue.ts';

export function useQueueStatus(): QueueStatus {
  const [status, setStatus] = useState<QueueStatus>(queueStatus);
  useEffect(() => onQueueChange(setStatus), []);
  return status;
}
